import { render, staticRenderFns } from "./tabView.vue?vue&type=template&id=5c8853a1"
import script from "./tabView.vue?vue&type=script&lang=js"
export * from "./tabView.vue?vue&type=script&lang=js"
import style0 from "./tabView.vue?vue&type=style&index=0&id=5c8853a1&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports